package org.example.project.model

import kotlinx.serialization.Serializable

@Serializable
data class SerializedShip(
    val type: String = "",
    val row: Int = 0,
    val col: Int = 0,
    val horizontal: Boolean = true
) {
    fun toPlacedShip(): PlacedShip =
        PlacedShip(
            type = ShipType.valueOf(type),
            row = row,
            col = col,
            horizontal = horizontal
        )

    companion object {
        fun fromPlacedShip(ship: PlacedShip): SerializedShip =
            SerializedShip(
                type = ship.type.name,
                row = ship.row,
                col = ship.col,
                horizontal = ship.horizontal
            )
    }
}
